<dx-form
  #socialFormRef
  class="social-form__form"
  [formData]="formData"
  [validationGroup]="validationGroup"
  labelMode="floating"
  [scrollingEnabled]="true"
  (onFieldDataChanged)="socialFormRef?.instance?.validate()"
>
  @if (includeSocialType) {
    <dxi-item
      [isRequired]="true"
      [dataField]="SocialKeys.socialType"
      [editorType]="'dxSelectBox'"
      [label]="{ text: 'Type' }"
      [editorOptions]="{
        items: socialTypesLookup,
        displayExpr: LookupKeys.description,
        valueExpr: BaseModelKeys.dbId,
        showClearButton: false,
      }"
    >
      <dxi-validation-rule type="required" [message]="'Type is Required'"></dxi-validation-rule>
    </dxi-item>
  }

  <dxi-item
    [isRequired]="true"
    [dataField]="SocialKeys.socialMedia"
    [editorType]="'dxSelectBox'"
    [label]="{ text: 'Social Media' }"
    [editorOptions]="{
      items: socialMediaLookup,
      displayExpr: LookupKeys.description,
      valueExpr: BaseModelKeys.dbId,
      showClearButton: false,
    }"
  >
    <dxi-validation-rule type="required" [message]="'Social Media is Required'"></dxi-validation-rule>
  </dxi-item>

  <ng-container *var="formData?.[SocialKeys.socialMedia] as socialMedia">
    @switch (true) {
      @case (["FB", "TW", "TT"].includes(socialMedia)) {
        <ng-container
          *ngTemplateOutlet="accountIdItemTemplate; context: { url: socialMediaUrlMap[socialMedia], subFolder: '' }"
        ></ng-container>
      }
      @case (["IG"].includes(socialMedia)) {
        <ng-container
          *ngTemplateOutlet="accountIdItemTemplate; context: { url: socialMediaUrlMap[socialMedia], subFolder: '' }"
        ></ng-container>
      }

      @case (["LI"].includes(socialMedia)) {
        <dxi-item
          [isRequired]="true"
          [dataField]="SocialKeys.accountType"
          [editorType]="'dxSelectBox'"
          editorType="dxTextBox"
          [label]="{ text: 'Linked In Type' }"
          [editorOptions]="{
            items: LINKED_IN_TYPE_LOOKUP,
            displayExpr: LookupKeys.description,
            valueExpr: LookupKeys.value,
            showClearButton: false,
          }"
        >
          <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
        </dxi-item>

        <ng-container
          *ngTemplateOutlet="
            accountIdItemTemplate;
            context: { url: socialMediaUrlMap[socialMedia], subFolder: formData?.[SocialKeys.accountType] ?? '' }
          "
        ></ng-container>
      }

      @case (["YT"].includes(socialMedia)) {
        <dxi-item
          [isRequired]="true"
          [dataField]="SocialKeys.accountType"
          [editorType]="'dxSelectBox'"
          editorType="dxTextBox"
          [label]="{ text: 'Youtube Type' }"
          [editorOptions]="{
            items: YOUTUBE_TYPE_LOOKUP,
            displayExpr: LookupKeys.description,
            valueExpr: LookupKeys.value,
            showClearButton: false,
          }"
        >
          <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
        </dxi-item>

        <ng-container
          *ngTemplateOutlet="
            accountIdItemTemplate;
            context: { url: socialMediaUrlMap[socialMedia], subFolder: formData?.[SocialKeys.accountType] ?? '' }
          "
        ></ng-container>
      }

      @default {
        <dxi-item
          [isRequired]="true"
          [dataField]="SocialKeys.url"
          editorType="dxTextBox"
          [label]="{ text: 'URL' }"
          [editorOptions]="{
            readOnly: isTypeDependentForm && !this.formData?.[SocialKeys.socialType],
          }"
        >
          <dxi-validation-rule
            type="custom"
            [message]="Messages.INVALID_URL_FORMAT_TEXT"
            [validationCallback]="validateUrlWithOrWithoutProtocol"
          ></dxi-validation-rule>
          <dxi-validation-rule type="required" [message]="Messages.REQUIRED_URL_TEXT"></dxi-validation-rule>
        </dxi-item>
      }
    }

    <ng-template #accountIdItemTemplate let-url="url" let-subFolder="subFolder">
      <dxi-item
        cssClass="social-form__combined-textbox"
        [isRequired]="true"
        [dataField]="SocialKeys.accountId"
        editorType="dxTextBox"
        [label]="{ text: 'User Name' }"
        [editorOptions]="{
          valueChangeEvent: 'input',
          readOnly: isTypeDependentForm && !this.formData?.[SocialKeys.socialType],
          buttons: [
            {
              name: 'url',
              location: 'before',
              options: {
                text: url + subFolder,
                stylingMode: 'text',
                disabled: true,
                elementAttr: {
                  class: 'social-form__url_button',
                },
              },
            },
          ],
          onPaste: onPasteHandler.bind(this)
        }"
      >
        <dxi-validation-rule type="required" [message]="'User Name is Required'"></dxi-validation-rule>
        <dxi-validation-rule
          type="custom"
          [validationCallback]="validateUserName"
          message="User Name is not Valid">
        </dxi-validation-rule>
      </dxi-item>
    </ng-template>
  </ng-container>
</dx-form>
